<template>
  <div class="roar-filter-panel">
    <div class="select-group">
      <div class="select-group-item select-brand">
        <div class="option-cb">
          <a-checkbox
            v-model:checked="allChecked"
            @change="handleAllCheckedChange"
          >
            {{ $t('admin.All') }}
          </a-checkbox>
        </div>
        <a-checkbox-group
          v-model:value="roarChecked"
          name="brandG"
          class="cb-group"
        >
          <div v-for="(item, index) in options" :key="index" class="option-cb">
            <a-checkbox :value="item.value">
              {{ item.text }}
            </a-checkbox>
          </div>
        </a-checkbox-group>
      </div>
    </div>
    <div class="action-group">
      <a-button type="link" @click="reset" :disabled="roarChecked == 0">
        Reset
      </a-button>
      <a-button class="action-ok" type="primary" @click="applyFilter">
        OK
      </a-button>
    </div>
  </div>
</template>
<script>
  import { toRaw } from '@vue/reactivity'
  export default {
    name: 'RoarFilter',
    components: {},
    props: {
      setSelectedKeys: {
        default: () => {},
      },
      selectedKeys: {
        default: {},
      },
      confirm: {
        default: () => {},
      },
      clearFilters: {
        default: () => {},
      },
      column: {
        default: {},
      },
      name: {
        default: '',
      },
      options: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        roarChecked: [],
        allChecked: false,
        allIndeterminate: false,
      }
    },
    created() {
      this.roarChecked = this.selectedKeys.brand || []
    },
    computed: {},
    watch: {
      roarChecked(val) {
        this.watchCheckBox(val)
      },
    },
    methods: {
      watchCheckBox(val) {
        this.allIndeterminate =
          val.length != this.options.length && val.length != 0
        this.allChecked = val.length == this.options.length
      },
      reset() {
        this.roarChecked = []

        this.clearFilters()
      },
      applyFilter() {
        // function formateAllcheckedData(options, value) {
        //   if (options.length === value.length) {
        //     return []
        //   } else {
        //     return toRaw(value)
        //   }
        // }
        // const data = ['brand', 'role', 'level'].map((key) => {
        //   return {
        //     key,
        //     value: formateAllcheckedData(
        //       this.options[key],
        //       this[`${key}Checked`]
        //     ),
        //   }
        // })
        this.setSelectedKeys(this.roarChecked)
        this.confirm()
      },
      handleAllCheckedChange() {
        this.roarChecked = this.allChecked
          ? this.options.map((item) => item.value)
          : []
      },
    },
  }
</script>
<style lang="less">
  @import url('@/styles/params.less');
  .roar-filter-panel {
    background-color: white;
  }

  .option-cb {
    font-size: 14px;
    font-family: Helvetica;
    color: #333333;
    line-height: 22px;
    padding: 5px 12px;
  }
  .select-group {
    padding: 4px 0;
    display: flex;
    justify-content: center;
    .select-group-item {
      max-height: 300px;
      overflow: auto;
    }
  }
  .action-group {
    padding: 7px 8px;

    border-top: 1px solid #0000000f;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .ant-btn {
      height: auto !important;
      padding: 0 7px;
    }

    .action-ok {
      font-size: 14px;
    }
  }
</style>
